// extracted by mini-css-extract-plugin
export default {"emailverify":"style_emailverify__Rr3Fx"};